<template>
	<div>
		<loading :active.sync="isLoading"></loading>
		<transactionManage :transaction="row" v-if="row"/>
		<div class="row pt-5" v-if="row">
      <div class="col-12 p-0 text-left">
        <div class="listy b-b">
					<span class="label">
						{{ t.assigned }}
					</span>
          <div class="search-input">
            <userAutoComplete :place="t.search_user" v-on:selected="assignTo" />
          </div>

          <div class="users-list-w">
            <div class="user-w with-status" :class="(row.assigned.online) ? 'status-green' : 'status-red'" v-if="row.assigned">
              <div class="user-avatar-w">
                <div class="user-avatar">
                  <img alt="" :src="api+'api/v1/users/get/profile_pic/'+row.assigned.id"></div>
              </div>
              <div class="user-name">
                <h6 class="user-title">{{ row.assigned.name }}</h6>
                <div class="user-role">{{ row.assigned.username }}</div>s
              </div>
              <a class="user-action" href="javascript:;">
                <div v-on:click="unassignTransaction(null)" class="os-icon os-icon-cancel-circle"></div>
              </a>
            </div>
          </div>
        </div>
      </div>
			<div class="col-m-12 col-xl-12 text-left">
				<div class="col-12 p-0" v-if="row.operator">
					<div class="listy b-b">
					<span class="label">
						{{ t.editor }}
					</span>
						<router-link :to="{name: 'userprofile', params: {id: row.operator.id}}">
							{{ row.operator.username }}
						</router-link>
					</div>
				</div>
				<div class="col-6 p-0">
					<div class="listy b-b">
						<span class="label">
							{{ t.created_at }}
						</span>
						{{ dateTimeFormat(row.addedAt) }} <br />
						<span class="text-danger">{{ row.addedAt | timeAgo }}</span>
					</div>
				</div>
        <div class="col-6 p-0">
          <div class="listy b-b">
						<span class="label">
							Note
						</span>
            {{ row.note }}
          </div>
        </div>
				<div class="col-12 p-0">
					<div class="listy b-b">
					<span class="label">
						{{ t.amount }}
					</span>
						{{ row.amount | toMoney(row.currency) }}
					</div>
				</div>
        <div class="col-12 p-0">
          <div class="listy b-b">
					<span class="label">
						{{ t.user.full_name }}
					</span>
            <router-link :to="{name: 'userprofile', params: {id: row.user.id}}">
              {{ row.user.name }}
            </router-link>
          </div>
        </div>
				<div class="col-12 p-0">
					<div class="listy b-b">
					<span class="label">
						{{ t.user.username }}
					</span>
						<router-link :to="{name: 'userprofile', params: {id: row.user.id}}">
							{{ row.user.username }} ({{ row.user.balance | toMoney(row.user.currency) }})
						</router-link>
					</div>
				</div>
				<div class="col-12 p-0">
					<div class="listy b-b">
					<span class="label">
						{{ t.description }}
					</span>
						{{ row.info }}
					</div>
				</div>
				<div class="col-12 p-0">
					<div class="listy b-b">
					<span class="label">
						{{ t.status }}
					</span>
						{{ row.status }}
					</div>
				</div>
				<div class="col-12 p-0">
					<div class="listy b-b">
					<span class="label">
						{{ t.old_real_money }}
					</span>
						{{ row.oldRealMoney | toMoney(row.user.currency) }}
					</div>
				</div>
				<div class="col-12 p-0">
					<div class="listy b-b">
					<span class="label">
						{{ t.new_real_money }}
					</span>
						{{ row.newRealMoney | toMoney(row.user.currency) }}
					</div>
				</div>
				<div class="col-12 p-0">
					<div class="listy b-b">
					<span class="label">
						{{ t.old_bonus }}
					</span>
						{{ row.oldBonus | toMoney(row.user.currency) }}
					</div>
				</div>
				<div class="col-12 p-0">
					<div class="listy b-b">
					<span class="label">
						{{ t.new_bonus}}
					</span>
						{{ row.newBonus | toMoney(row.user.currency) }}
					</div>
				</div>

				<div class="col-12 p-0" v-if="row.method">
					<div class="listy b-b">
					<span class="label">
						{{ t.payment_methods}}
					</span>
						{{ row.method.name }}
					</div>
				</div>
        <div class="col-12 p-0" v-if="row.gameId">
          <div class="listy b-b">
            <span class="label">
              Game
            </span>
            <gameCard v-if="row.gameId" :vendor="row.provider" :gameId="row.gameId" />
          </div>
        </div>
			</div>
			<div class="col-12">
				<BankAccountDetail :id.sync="row.dataId" v-if="row.dataId && row.type.key == 'withdraw_transfer_to_bank_account'" />
				<metaView :id.sync="row.id" v-if="row.id" />
			</div>
		</div>
	</div>
</template>

<script>
    import gameCard from '@/components/casino/gameCard'
    import userAutoComplete from '@/components/autocomplete/userAutoComplete'
	  import transactionManage from '@/components/accounting/transactionManage'
	  import BankAccountDetail from '@/components/accounting/BankAccountDetail'
    import metaView from '@/components/accounting/transactionMetaView'
    export default {
        name: 'transactionDetail',
        components: {BankAccountDetail, transactionManage, metaView, userAutoComplete, gameCard},
        props: {
              id: {
                  default: 0
              }
        },
        watch: {
            'id' () {
                this.fetchTransaction();
            }
        },
        data () {
            return {
                api: window.api,
                t: this.$root.t,
                row: null,
                status: 0,
                isLoading: false,
                assigned: null
            }
        },
	    mounted () {
            this.fetchTransaction();
	    },
	    methods: {
            assignTo (s) {
                this.assigned = s
                this.assignTransaction()
            },
            unassignTransaction () {
                this.isLoading = true;
                this.$http.post(api+'api/v1/transaction/unassign', {id: this.id}).then(
                    response => {
                        // get body data
                        this.fetchTransaction();

                    }, response => {
                        this.isLoading = false;
                        this.status = response.status;
                    })
            },
            assignTransaction () {
                this.isLoading = true;
                this.$http.post(api+'api/v1/transaction/assign', {id: this.id, uid: this.assigned.id}).then(
                    response => {
                        // get body data
                        this.fetchTransaction();

                    }, response => {
                        this.isLoading = false;
                        this.status = response.status;
                    })
            },
            fetchTransaction () {
                this.row = null;
                this.isLoading = true;
                this.$http.get(api+'api/v1/user/transactions', { params:{transactionId: [this.id], _: Date.now()} }).then(
                    response => {
                    // get body data
                    this.row = response.body.result.transactions[0];
                    this.isLoading = false;
                    this.status = response.status;

                }, response => {
                    this.isLoading = false;
                    this.status = response.status;
                })
            }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/accounting/transactionDetail.vue